import { isBuyOnceId } from './buy-once'
import { getProductPrice } from '../store/product/getters'
import { productState } from '../store/product/index'

export interface SellingPlanAllocation {
  groupId: string
  sellingPlanId: number
  price: number
}

export const getLowestDiscountByGroupForVariant = (groupId: string): number => {
  if (!productState.currentVariant) {
    return getProductPrice()
  }
  const defaultVariantAllocation = productState.currentVariant.sellingPlanAllocations
    .filter(allocation => allocation.groupId === groupId && allocation.price > 0)
    .sort((alloc1, alloc2) => {
      return alloc1.price - alloc2.price
    })
  return defaultVariantAllocation[0] ? defaultVariantAllocation[0].price : getProductPrice()
}

export const getSellingPlanAllocationForVariant = (groupId: string, planId: number): number => {
  if (!productState.currentVariant) {
    return getProductPrice()
  }
  if (isBuyOnceId(groupId)) {
    return productState.currentVariant.price
  }
  const defaultVariantAllocation = productState.currentVariant.sellingPlanAllocations.find(allocation =>
    allocation.groupId === groupId &&
      allocation.sellingPlanId === planId &&
      allocation.price > 0)
  return defaultVariantAllocation ? defaultVariantAllocation.price : getProductPrice()
}
